
import { useEffect, useState } from 'react';

export default function WhiteningHero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="pt-16">
      <section className="relative min-h-screen flex items-center justify-center px-6 lg:px-12 pt-32 pb-24">
        <div className="absolute inset-0 z-0">
          <img
            src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/cec8aaca26e455f245c93824d3402f37.jpeg"
            alt="医療ホワイトニング"
            className="w-full h-full object-cover object-top"
            fetchPriority="high"
          />
          <div className="absolute inset-0 bg-white/70"></div>
        </div>

        <div className="max-w-4xl w-full relative z-10">
          <div
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
              transition: 'opacity 2000ms ease-out, transform 2000ms ease-out',
            }}
          >
            <h1 className="leading-relaxed mb-20 font-serif">
              <span
                className="block text-sm font-medium tracking-widest mb-3"
                style={{ fontFamily: 'Noto Sans JP, sans-serif', color: '#3E5F8F' }}
              >
                医療ホワイトニング 札幌 | さいわいデンタル moyuk SAPPORO
              </span>
              <span className="block text-3xl lg:text-6xl text-gray-900">白さを、感覚ではなく</span>
              <span className="block text-3xl lg:text-6xl text-gray-900 ml-0 lg:ml-8">医療として設計する。</span>
            </h1>
          </div>

          <p className="text-base lg:text-lg text-gray-600 leading-loose max-w-2xl">
            さいわいデンタルクリニックは<br />
            「医療ホワイトニング」で<br />
            確信を持てる白さを設計します。
          </p>

          <div className="flex flex-col gap-4 mt-12 max-w-xs">
            <a
              href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-[#3E5F8F] hover:bg-[#344F78] text-white text-sm px-8 py-4 rounded-full transition-colors duration-300 whitespace-nowrap cursor-pointer shadow-sm"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-calendar-line text-sm"></i>
              </span>
              WEB予約
            </a>
            <a
              href="tel:05018094594"
              className="flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-gray-800 text-sm px-8 py-4 rounded-full transition-colors duration-300 whitespace-nowrap cursor-pointer shadow-sm border border-gray-200"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-sm"></i>
              </span>
              電話で相談
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
